<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eoe2rN/cover.jpg?1700571432974" alt="This image is the cover for the book Five O'Clock Lightning"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Five O'Clock Lightning
      </h1>
      <p class="bookDescription body article font2">
        <b>A onetime baseball catcher confronts the murder of a McCarthyist politician at Yankee Stadium</b><br/>In 1953 America, McCarthyism is everywhere. Congressman Rex Harwood Simmons is among the leaders who single-mindedly hunt down suspected Communists; he even claims that Communism has infiltrated America’s favorite pastime. But while watching a Yankee game one afternoon, he becomes a target. As the crowd cheers for a homerun, Simmons is shot dead in his seat.           The task of solving the crime falls to onetime ballplayer and Korean War veteran Russ Garrett, who collaborates with “Vicious Aloysius” Murphy, a Bronx homicide detective. The investigation won’t be easy, since there are plenty of people with a motive to plug Simmons. Several clues point to a blacklisted intellectual—but he was driven to suicide years ago. And as Garrett hunts for the killer, a new conspiracy comes to light: a plot to murder Yankee star Mickey Mantle.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William L. DeAndrea
      </h2>
      
      <p class="authorDescription body article">William L. DeAndrea (1952&ndash;1996) was born in Port Chester, New York. While working at the Murder Ink bookstore in New York City, he met mystery writer Jane Haddam, who became his wife. His first book, <i>Killed in the Ratings</i> (1978), won an Edgar Award in the best first mystery novel category. That debut launched a series centered on Matt Cobb, an executive problem-solver for a TV network who unravels murders alongside corporate foul play. DeAndrea&rsquo;s other series included the Nero Wolfe&ndash;inspired Niccolo Benedetti novels, the Clifford Driscoll espionage series, and the Lobo Blacke/Quinn Booker Old West mysteries. A devoted student of the mystery genre, he also wrote a popular column for the<i> Armchair Detective</i> newsletter. One of his last works, the Edgar Award&ndash;winning <i>Encyclopedia Mysteriosa</i> (1994), is a thorough reference guide to sleuthing in books, film, radio, and TV.&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f7d9fd8